module.exports = __webpack_public_path__ + "static/current-row.eaec2b5f.png";